import { obterJson } from './v2/api';
import { formatar, textos, url } from './v2/config';
import { iniciarMedicaoPagina } from './v2/medicao';
import { irPara } from './v2/sobreposicao';

// Guia de profissões (renderProfissoes e a busca do guia da v37). O servidor manda as 640 profissões, as áreas e todas
// as letras; aqui ficam a busca com sugestões, a letra e a área escolhidas e o "Ver todas as áreas".
const $ = id => document.getElementById(id);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const fmt = n => Number(n).toLocaleString(document.documentElement.lang || 'pt-BR');
const ehCelular = () => !window.matchMedia('(min-width: 960px)').matches;
const semAnimacao = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const T = textos($('pfGuia'));
const anunciosN = n => (n === 1 ? T.umAnuncio : formatar(T.anunciosN, fmt(n)));

// ---------- busca do guia: cada termo é o começo de uma palavra do nome ou de um outro nome, sem acento ----------
const normal = s => String(s || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
const termosDe = q => normal(q).split(/[^a-z0-9]+/).filter(Boolean);
let _indice = null;
let _carregando = null;

// [título, url, anúncios, outros nomes]: só baixa quando a pessoa usa a busca (os outros nomes são 4 mil).
function carregarIndice() {
    _carregando ??= obterJson(url('/profissoes?parcial=busca'))
        .then(lista => { _indice = lista; })
        .catch(() => { _carregando = null; });
    return _carregando;
}

function sugestoes(q) {
    const termos = termosDe(q);
    if (!termos.length || !_indice) {
        return [];
    }
    const casa = s => {
        const palavras = normal(s).split(/[^a-z0-9]+/).filter(Boolean);
        return termos.every(t => palavras.some(w => w.startsWith(t)));
    };
    const porNome = _indice.filter(x => casa(x[0])).map(x => ({ t: x[0], u: x[1], n: x[2], via: '' }));
    const ja = new Set(porNome.map(o => o.u));
    const porOutro = _indice.filter(x => !ja.has(x[1])).map(x => ({ t: x[0], u: x[1], n: x[2], via: (x[3] || []).find(casa) })).filter(o => o.via);
    const comeca = o => (normal(o.t).startsWith(termos[0]) ? 0 : 1);
    porNome.sort((a, b) => comeca(a) - comeca(b) || a.t.localeCompare(b.t, 'pt-BR'));
    return [...porNome, ...porOutro].slice(0, 8);
}

// O pedaço digitado em negrito, no começo de cada palavra.
const realce = (texto, q) => {
    const termos = termosDe(q);
    return String(texto).split(/(\s+)/).map(w => {
        const n = normal(w);
        const t = termos.filter(x => n.startsWith(x)).sort((a, b) => b.length - a.length)[0];
        return t ? `<b>${esc(w.slice(0, t.length))}</b>${esc(w.slice(t.length))}` : esc(w);
    }).join('');
};

let _ativo = -1;
let _itens = [];

async function desenharSugestoes() {
    const campo = $('pfQ');
    const caixa = $('pfAc');
    const q = campo.value.trim();
    $$('[data-pf-clr]').forEach(b => { b.hidden = !campo.value; });
    if (q.length < 2) {
        fecharSugestoes();
        _itens = [];
        return;
    }
    if (!_indice) {
        await carregarIndice();
        // Sem o índice (a rede caiu) a busca não sugere; a próxima tecla tenta de novo.
        if (!_indice || campo.value.trim() !== q) {
            return;
        }
    }
    _itens = sugestoes(q);
    _ativo = -1;
    caixa.innerHTML = _itens.length
        ? _itens.map((o, i) => `<li class="pf__opt" role="option" id="pfo-${i}" aria-selected="false" data-pf-opt="${i}"><span>${realce(o.t, q)}</span>${o.via ? `<small>${formatar(esc(T.tambem), realce(o.via, q))}</small>` : ''}<span class="pf__optn">${o.n ? esc(anunciosN(o.n)) : ''}</span></li>`).join('')
        : `<li class="pf__acv" role="presentation">${esc(T.nenhuma)} <a href="${esc(`${T.urlVagas}?query=${encodeURIComponent(q)}`)}">${esc(formatar(T.buscarVagas, q))}</a></li>`;
    caixa.hidden = false;
    campo.setAttribute('aria-expanded', 'true');
    campo.removeAttribute('aria-activedescendant');
}

function moverSugestao(d) {
    if (!_itens.length) {
        return;
    }
    _ativo = (_ativo + d + _itens.length) % _itens.length;
    $$('#pfAc .pf__opt').forEach((li, i) => li.setAttribute('aria-selected', String(i === _ativo)));
    $('pfQ').setAttribute('aria-activedescendant', `pfo-${_ativo}`);
    $(`pfo-${_ativo}`)?.scrollIntoView({ block: 'nearest' });
}

function fecharSugestoes() {
    const caixa = $('pfAc');
    const campo = $('pfQ');
    if (caixa) {
        caixa.hidden = true;
    }
    if (campo) {
        campo.setAttribute('aria-expanded', 'false');
        campo.removeAttribute('aria-activedescendant');
    }
    _ativo = -1;
}

const abrirProfissao = u => {
    fecharSugestoes();
    irPara(`${T.urlProfissao}${u}`);
};

// ---------- letras e áreas ----------
const lista = () => $('pfLista');
const rolarParaLista = () => {
    const l = lista();
    if (!l) {
        return;
    }
    const topo = l.getBoundingClientRect().top - (document.querySelector('.site-h')?.offsetHeight || 0) - 12;
    window.scrollTo({ top: window.scrollY + topo, behavior: semAnimacao() ? 'auto' : 'smooth' });
};

function escolherLetra(letra) {
    $$('#pfAZ .pf__grp').forEach(g => {
        const aberta = g.dataset.letra === letra;
        aberta ? g.removeAttribute('hidden') : g.setAttribute('hidden', 'until-found');
    });
    $$('[data-pf-letra]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.pfLetra === letra)));
}

// A lista da área sai das profissões de A a Z que já estão na página (cada uma sabe as áreas dela).
function escolherArea(id) {
    const areas = $('pfAreas');
    $$('[data-pf-area]', areas || document).forEach(b => {
        const on = +b.dataset.pfArea === id && id > 0;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
    });
    const az = $('pfAZ');
    const daArea = $('pfArea');
    if (!id) {
        daArea.hidden = true;
        daArea.replaceChildren();
        az.hidden = false;
        lista().setAttribute('aria-labelledby', 'pfListaT');
        return;
    }
    const botao = areas?.querySelector(`[data-pf-area="${id}"]`);
    const nome = botao?.firstChild?.textContent.trim() || '';
    const itens = $$('#pfAZ .pf__ul li').filter(li => (li.dataset.a || '').split(' ').includes(String(id)));
    const grupos = new Map();
    itens.forEach(li => {
        const letra = li.closest('.pf__grp').dataset.letra;
        if (!grupos.has(letra)) {
            grupos.set(letra, []);
        }
        grupos.get(letra).push(li.querySelector('a'));
    });
    daArea.innerHTML = `<div class="pf__sech"><h2 id="pfAreaT" tabindex="-1">${esc(formatar(T.profissoesDe, nome))} <small>(${itens.length})</small></h2><button class="linkbtn" type="button" data-pf-area="0">${esc(T.verTodasAZ)}</button></div>
        ${[...grupos].map(([letra, links]) => `<div class="pf__grp"><h3 class="pf__lt">${esc(letra)}</h3><ul class="pf__ul">${links.map(a => `<li><a href="${esc(a.getAttribute('href'))}">${esc(a.textContent)}</a></li>`).join('')}</ul></div>`).join('')}`;
    az.hidden = true;
    daArea.hidden = false;
    lista().setAttribute('aria-labelledby', 'pfAreaT');
}

// ---------- eventos ----------
function iniciarEventos() {
    const campo = $('pfQ');
    campo?.addEventListener('input', desenharSugestoes);
    campo?.addEventListener('focus', () => {
        carregarIndice();
        if (campo.value.trim().length >= 2) {
            desenharSugestoes();
        }
    });
    // Fecha quando o foco sai da busca (campo, Limpar e lista): o Tab leva ao "Buscar vagas de…" sem fechar.
    const busca = campo?.closest('.pf__busca');
    busca?.addEventListener('focusout', () => setTimeout(() => {
        if (!busca.contains(document.activeElement)) {
            fecharSugestoes();
        }
    }, 150));
    campo?.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if ($('pfAc').hidden) {
                desenharSugestoes();
            }
            moverSugestao(1);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            moverSugestao(-1);
        } else if (e.key === 'Enter') {
            e.preventDefault();
            const o = _itens[_ativo >= 0 ? _ativo : 0];
            if (o) {
                abrirProfissao(o.u);
            }
        } else if (e.key === 'Escape' && !$('pfAc').hidden) {
            e.stopPropagation();
            fecharSugestoes();
        }
    });
    // A opção e o link não tiram o foco do campo (o blur fecharia a lista antes do clique).
    $('pfAc')?.addEventListener('pointerdown', e => {
        if (e.target.closest('.pf__opt, a')) {
            e.preventDefault();
        }
    });

    document.addEventListener('click', e => {
        const t = e.target;
        const opcao = t.closest('[data-pf-opt]');
        if (opcao) {
            const o = _itens[+opcao.dataset.pfOpt];
            if (o) {
                abrirProfissao(o.u);
            }
            return;
        }
        if (t.closest('[data-pf-clr]')) {
            campo.value = '';
            desenharSugestoes();
            campo.focus();
            return;
        }
        const letra = t.closest('[data-pf-letra]');
        if (letra) {
            escolherLetra(letra.dataset.pfLetra);
            letra.focus({ preventScroll: true });
            letra.scrollIntoView({ block: 'nearest', inline: 'center' });
            return;
        }
        if (t.closest('[data-pf-areas-all]')) {
            const areas = $('pfAreas');
            areas.classList.add('is-all');
            // O foco vai para a primeira área que apareceu.
            areas.querySelector(ehCelular() ? '.pf__a6' : '.pf__a12')?.focus();
            return;
        }
        const area = t.closest('[data-pf-area]');
        if (area) {
            const id = +area.dataset.pfArea;
            const atual = +($('pfAreas')?.querySelector('.chip.is-on')?.dataset.pfArea || 0);
            escolherArea(id && id !== atual ? id : 0);
            rolarParaLista();
            $(id && id !== atual ? 'pfAreaT' : 'pfListaT')?.focus({ preventScroll: true });
        }
    });

    // Ctrl+F achou uma profissão de outra letra: o navegador abre o grupo dela, e a letra escolhida acompanha.
    document.addEventListener('beforematch', e => {
        const grupo = e.target.closest?.('#pfAZ .pf__grp');
        if (grupo) {
            escolherLetra(grupo.dataset.letra);
        }
    }, true);
}

// ---------- início ----------
if ('onbeforematch' in document.body) {
    document.documentElement.classList.add('ate-achar');
}
iniciarMedicaoPagina('profissoes');
iniciarEventos();
